<template>
  <transition :name="slideStyle">
    <city-view
      v-if="showStatus"
      :hide="hide"
      :backStyle="backStyle"
      :canSearchSpell="canSearchSpell"
      @closeChooseCity="closeChooseCity"
      @locationError="handleLocationError"
      :location="location"
    ></city-view>
  </transition>
</template>

<script setup>
import { computed, ref } from 'vue';
import CityView from './view.vue';

defineOptions({name: 'BestCity'});

const props = defineProps({
  canSearchSpell: {
    type: Boolean,
    default: true
  },
  location: {
    type: Object,
    default: () => ({
      acronym: 'bj',
      firstChar: 'B',
      id: 1,
      name: '北京',
      pinyin: 'beijing',
      rank: 'S'
    })
  },
  slide: {
    type: String,
    default: 'vertical'
  },
  backStyle: {
    type: String,
    default: 'retreat'
  }
});

const emit = defineEmits(['closeChooseCity', 'locationError']);
const showStatus = ref(false);
const slideStyle = computed(() => (
  props.slide === 'horizontal' ? 'horizontalSide' : 'verticalSide'
));

function show () {
  showStatus.value = true;
}

function hide () {
  showStatus.value = false;
}

function closeChooseCity (result) {
  emit('closeChooseCity', result);
}

function handleLocationError (message) {
  emit('locationError', message);
}

defineExpose({show, hide});
</script>
<style lang="stylus">
@import url('https://at.alicdn.com/t/font_1125658_wv3sr6cqm8f.css')
@import './common/stylus/index.styl'
.horizontalSide-enter-active, .horizontalSide-leave-active, .verticalSide-enter-active, .verticalSide-leave-active
  transition all 0.2s ease
.horizontalSide-enter-from, .horizontalSide-leave-to
  transform translateX(100%)
.verticalSide-enter-from, .verticalSide-leave-to
  transform translateY(-100%)
</style>
